import { ParsedUrlQuery } from 'querystring'

const stringifyQuery = (query: ParsedUrlQuery): Record<string, string> =>
  Object.keys(query).reduce<Record<string, string>>((acc, curr) => {
    const value = query[curr]
    acc[curr] = typeof value === 'string' ? value : value[0]
    return acc
  }, {})

export default stringifyQuery
